import { create } from "zustand";

interface ISidebarState {
  collapsed: boolean;
  mobileOpen: boolean;
  toggleCollapsed: () => void;
  setCollapsed: (value: boolean) => void;
  toggleMobile: () => void;
  closeMobile: () => void;
}

const readInitial = () => {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem("sidebar:collapsed") === "1";
  } catch {
    return false;
  }
};

const persist = (value: boolean) => {
  try {
    window.localStorage.setItem("sidebar:collapsed", value ? "1" : "0");
  } catch {
    /* no-op */
  }
};

export const useSidebar = create<ISidebarState>((set) => ({
  collapsed: readInitial(),
  mobileOpen: false,
  toggleCollapsed: () =>
    set((prev) => {
      const next = !prev.collapsed;
      persist(next);
      return { collapsed: next };
    }),
  setCollapsed: (value) =>
    set(() => {
      persist(value);
      return { collapsed: value };
    }),
  toggleMobile: () => set((prev) => ({ mobileOpen: !prev.mobileOpen })),
  closeMobile: () => set({ mobileOpen: false }),
}));
